import { graphql } from 'react-relay';

// 취소 사유 목록 조회 쿼리 V2 (corpType: "INDIS" | "CORPS", itrfCd: 종합소득세(10), 양도소득세(22), 법인세(31))
export const cancelReasonsV2Query = graphql`
  query cancelReasonsV2Query($corpType: String!, $itrfCd: String!) {
    cancelReasonsV2(corpType: $corpType, itrfCd: $itrfCd) {
      result
      errors {
        code
        message
      }
      reasons {
        id
        sequence
        title
        content
        reason
        label
        active
      }
    }
  }
`;

// 환급 취소 신청 뮤테이션 (종합소득세/법인세)
export const applyCancelMutation = graphql`
  mutation cancelApplyMutation($refundId: String!, $reasonId: ID!, $content: String) {
    data: applyCancel(applyInput: { refundId: $refundId, reasonId: $reasonId, content: $content }) {
      result
      errors {
        code
        message
      }
    }
  }
`;

// 환급 취소 신청 뮤테이션 (양도소득세)
export const tritxApplyCancelMutation = graphql`
  mutation cancelTritxApplyCancelMutation($refundId: String!, $reasonId: ID!, $content: String) {
    data: tritxApplyCancel(applyInput: { refundId: $refundId, reasonId: $reasonId, content: $content }) {
      result
      errors {
        code
        message
      }
    }
  }
`;
